<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="topHeader">请假人信息</span>
      </div>
      <div class="text item userInfo">
        <div>
          <span class="title">姓名：</span>
          <span class="cont">{{pageInfo.name?pageInfo.name:'未填写姓名'}}</span>
        </div>
        <div>
          <span class="title">所属单位：</span>
          <span class="cont">{{pageInfo.unit?pageInfo.unit:'未填写所属单位'}}</span>
        </div>
        <div>
          <span class="title">所属党组织：</span>
          <span class="cont">{{pageInfo.partyorg?pageInfo.partyorg:'未填写所属党组织'}}</span>
        </div>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="topHeader">请假信息</span>
      </div>
      <div class="text item leaveInfo">
        <div>
          <span class="title">请假时间：</span>
          <span class="cont">{{pageInfo.cdate?pageInfo.cdate:'未填写请假时间'}}</span>
        </div>
        <div class="fontWTitle">相关排课信息：</div>
        <div v-if="pageInfo.scheduling">
          <span class="title">所属学习班：</span>
          <span
            class="cont"
          >{{pageInfo.scheduling.studyClassName?pageInfo.scheduling.studyClassName:'未填写所属学习班'}}</span>
          <span class="title">开课单位：</span>
          <span
            class="cont"
          >{{pageInfo.scheduling.createunit?pageInfo.scheduling.createunit:'未填写开课单位'}}</span>
        </div>
        <div v-if="pageInfo.scheduling">
          <span class="title">开课时间：</span>
          <span class="cont">{{pageInfo.scheduling.durtime}}</span>
        </div>
        <div v-if="pageInfo.scheduling">
          <span class="title">包含课程：</span>
          <span
            class="cont"
            v-for="item in pageInfo.scheduling.courses"
            :key="item.id"
          >{{item.title}}</span>
        </div>
        <div class="fontWTitle">
          <span class="title">请假理由</span>
        </div>
        <div>
          <span class="cont">{{pageInfo.reason?pageInfo.reason:'未填写请假理由'}}</span>
        </div>
      </div>
    </el-card>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span class="topHeader">批复</span>
      </div>
      <div class="text item submitInfo">
        <div class="cont">
          <span>批复信息</span>
          <textarea cols="90" rows="5" v-model="replyinfo"></textarea>
        </div>
        <div class="bottomButton">
          <el-button type="success" class="mr-10" @click="chooseYes">同意</el-button>
          <el-button type="warning" @click="chooseNo">驳回</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import {
  getLeaveHandleApi,
  chooseYesApi,
  chooseNoApi,
} from "@/api/module/user/leave";

export default {
  name: "LeaveHandle",
  
  data() {
    return {
      id: "",
      pageInfo: "",
      replyinfo: ""
    };
  },
  
  methods: {
    chooseYes() {
      let data = {
        id: this.id,
        replyinfo: this.replyinfo,
      };
      chooseYesApi(data)
        .then((res) => {
          this.$message.success("批复成功！");
          setTimeout(() => {
            this.$router.replace({
              path: "/user/leave",
            });
          }, 2000);
        })
    },
    
    chooseNo() {
      let data = {
        id: this.id,
        replyinfo: this.replyinfo,
      };
      chooseNoApi(data)
        .then((res) => {
          this.$message.success("批复成功！");
          setTimeout(() => {
            this.$router.replace({
              path: "/user/leave",
            });
          }, 2000);
        })
    },
    
    getLeaveHandle() {
      let data = {
        id: this.id,
      };
      getLeaveHandleApi(data)
        .then((res) => {
          this.pageInfo = res;
          console.log(res);
        })
    },
    
    init() {
      this.getLeaveHandle();
    }
  },
  
  created() {
    this.id = this.$route.query.id;
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.box-card {
  margin-bottom: 20px;
}
.topHeader {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}
.item {
  font-size: 18px;
  display: flex;
  flex-wrap: wrap;
  & > div {
    flex: 1;
    margin-right: 10px;
    font-size: 14px;
    .title {
      color: #303133;
    }
    .cont {
      color: #666;
    }
  }
}
.leaveInfo {
  display: flex;
  flex-direction: column;
  & > div {
    margin-top: 10px;
  }
  .title {
    min-width: 120px;
    display: inline-block;
  }
  .cont {
    margin-right: 50px;
  }
  .fontWTitle {
    font-weight: bold;
    margin-top: 20px;
  }
}
.submitInfo {
  flex-direction: column;
  .cont {
    display: flex;
    align-items: flex-start;
    span {
      margin-right: 20px;
    }
    textarea {
      outline: none;
      padding: 10px;
    }
  }
  .bottomButton {
    margin-top: 20px;
  }
}
</style>